import * as React from 'react';
import { extractFormCellProps, FormCell, IFormCellProps } from '../FormCell';
import { mergeTests } from '../../test-utilities/mergeTests';
import styled from 'styled-components';
import { InputStyled } from '../TextInput';
import { CheckboxIconInputAndLabel } from './CheckboxIconAndLabel';
import { useState } from 'react';

const StyledInput = styled(InputStyled)`
  width: 0px;
`;

const paddingLeftSize = '24px';

export interface ICheckboxInputProps extends Omit<IFormCellProps, 'label'> {
  disabled?: boolean;
  name?: string;
  onChange?: (value: boolean) => void;
  onBlur?: React.EventHandler<any>;
  onFocus?: () => void;
  readOnly?: boolean;
  text?: string;
  value?: boolean | null;
}

export const CheckboxInput: React.FC<ICheckboxInputProps> = (props) => {
  const { formCellProps, inputProps } = extractFormCellProps(props);
  const dataTestClass = inputProps['data-test-class'] || 'check-box';
  const [focused, setFocused] = useState<boolean>(false);
  const onInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    setFocused(false);
    if (inputProps.onBlur) inputProps.onBlur(event);
  };
  const onInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (!inputProps.readOnly && inputProps.onChange) inputProps.onChange(evt.target.checked);
  };
  const onInputFocus = () => {
    setFocused(true);
    if (inputProps.onFocus) inputProps.onFocus();
  };

  return (
    <FormCell {...formCellProps} paddingLeftSize={paddingLeftSize} data-test-id={props['data-test-id']}>
      <label>
        <StyledInput
          name={inputProps.name}
          checked={!!inputProps.value}
          data-test-id={mergeTests(props['data-test-id'], 'checkbox-input')}
          data-test-class={dataTestClass}
          disabled={inputProps.disabled}
          onBlur={onInputBlur}
          onChange={onInputChange}
          onFocus={onInputFocus}
          readOnly={inputProps.readOnly}
          type="checkbox"
        />
        <CheckboxIconInputAndLabel
          checked={!!inputProps.value}
          focused={focused}
          disabled={!!inputProps.disabled}
          readOnly={!!inputProps.readOnly}
          data-test-class={dataTestClass}
          text={inputProps.text}
        />
      </label>
    </FormCell>
  );
};
